// ActionProvider.js
import React, { useState } from "react";
import {iniciarVenta, iniciarVentaDebug, manejarFlujoVenta} from "./actions/VentasHandler";
import { hacerConsulta } from "./actions/ApiHandler";
import { hacerConsultapaquetes } from "./actions/Promociones";
import { updateChatbotState } from "./actions/Utils";
import { manejarValidacion } from "./actions/ValidacionClienteHandler";
import { confirmarInsercionCliente } from "./actions/confirmarInsercionCliente";
import {manejarValidacionCobertura} from "./actions/ValidacionCoberturaHandler";
import { manejarValidacionCompleta } from "./actions/ValidacionCompletaHandler";


const ActionProvider = ({ createChatBotMessage, setState, children }) => {
  const [ventaState, setVentaState] = useState({
    etapa: null,
    datos: {},
  });

  // Estado para validación (puedes usar uno o distintos según flujo)
  const [validacionState, setValidacionState] = useState({ metodo: null });
  const [validacionCoberturaActiva, setIsValidacionCoberturaActiva] = useState({metodo: null });

  const isVentaActiva = () => ventaState.etapa !== null;
  const isValidacionActiva = () => validacionState.metodo !== null;
  const isValidacionCoberturaActiva = () => validacionCoberturaActiva.metodo !== null;

  const sendBotResponse = (message, options = {}) => {
    const botMessage = createChatBotMessage(message, options);
    updateChatbotState(setState, botMessage);
  };

  const handleTest = () => {
    const botMessage = createChatBotMessage("Esta es una prueba de mensaje.");
    updateChatbotState(setState, botMessage);
  };

  // Funciones de validación y consulta existentes
  const iniciarValidacionRapida = () => {
    setValidacionState({ metodo: null });
    const botMessage = createChatBotMessage(
      "Por favor, selecciona el método de validación:",
      { widget: "opcionesValidacionRapida" }
    );
    updateChatbotState(setState, botMessage);
  };

  const iniciarValidacionConjunto = () => {
    const botMessage = createChatBotMessage(
      "Por favor, ingresa los datos para la validación en conjunto:",
      { widget: "opcionesValidacionCliente" }
    );
    updateChatbotState(setState, botMessage);
  };

  const iniciarValidacionCobertura = () => {
    setIsValidacionCoberturaActiva({ metodo: null });
    const botMessage = createChatBotMessage(
        "Por favor, selecciona el método de validación de la cobertura:",
        { widget: "opcionesValidacionCobertura" }
    );
    updateChatbotState(setState, botMessage);
  };

  const manejarValidacionCliente = async (message) => {
    if (!validacionState.metodo) {
      sendBotResponse("Por favor, selecciona un método de validación primero.");
      return;
    }
    await manejarValidacion(
             message,
             validacionState.metodo,
             validacionState,      // 3️⃣ tu state de validación
             setValidacionState,   // 4️⃣ su setter
             setState,             // 5️⃣ setter del chatbot
             createChatBotMessage  // 6️⃣ fábrica de mensajes
         );
  };

  

  const manejarValidacionDeCobertura = async (message) => {
    if (!validacionCoberturaActiva || !validacionCoberturaActiva.metodo) {
      sendBotResponse("Por favor, selecciona un método de validación primero.");
      return;
    }
    await manejarValidacionCobertura(
        message,
        validacionCoberturaActiva.metodo,
        setState,
        createChatBotMessage
    );
  };

  // NUEVA FUNCIÓN: Confirmar inserción del cliente
  // Esta función estará disponible en las acciones del chatbot
  const confirmarInsercionClienteAction = (datosCliente) => {
    // Aquí se llama a la función que creamos en confirmarInsercionCliente.js
    confirmarInsercionCliente(datosCliente, setState, createChatBotMessage);
  };

  return (
    <div>
      {React.Children.map(children, (child) =>
        React.cloneElement(child, {
          actions: {
            sendBotResponse,
            handleTest,
            hacerConsulta: (message) =>
            hacerConsulta(message, setState, createChatBotMessage),
            hacerConsultapaquetes : (message) =>
            hacerConsultapaquetes (message, setState, createChatBotMessage),
            iniciarVenta: () => iniciarVenta(setVentaState, setState, createChatBotMessage),
            iniciarVentaDebug: () => iniciarVentaDebug(setVentaState, setState, createChatBotMessage),
            manejarFlujoVenta: (message) =>
              manejarFlujoVenta(
                message,
                ventaState,
                setVentaState,
                setState,
                createChatBotMessage
              ),
            isVentaActiva,
            isValidacionActiva,
            isValidacionCoberturaActiva,
            mostrarOpcionesValidacionCliente: () => {
              const botMessage = createChatBotMessage(
                "¿Cómo deseas validar la información?",
                { widget: "seleccionValidacion" }
              );
              updateChatbotState(setState, botMessage);
            },
            iniciarValidacionRapida,
            iniciarValidacionConjunto,
            iniciarValidacionCobertura,
            setValidacionMetodo: (metodo) => setValidacionState({ metodo }),
            setValidacionCoberturaMetodo: (metodo) => setIsValidacionCoberturaActiva({ metodo }),
            manejarValidacionCliente,
            manejarValidacionDeCobertura,
            manejarValidacionCompleta: (datos) => manejarValidacionCompleta(datos, setState, createChatBotMessage),

            // Agregamos la nueva acción para confirmar la inserción del cliente
            confirmarInsercionCliente: confirmarInsercionClienteAction,
          },
        })
      )}
    </div>
  );
};

export default ActionProvider;
